import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import Drp_DocSaveType from '../AccountDocSettings/Drp_DocSaveType.js';
import Auto_User from '../User/Auto_User.js';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import PN from "persian-number";
import {Modal} from "react-bootstrap";



const DocIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    const rowKey = 'Id';
    let navigate = useNavigate();
    const UserRef = useRef()
    const DocSaveTypeRef = useRef();
    const [List, setList] = useState([]);
    const [Id, setId] = useState(General.GuidEmpty())
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [State, setState] = useState("-1");
    const [DetailModal, setDetailModal] = useState(false);
    const [SaveType, setSaveType] = useState("-1");
    const [Comment, setComment] = useState('');
    const [SystemNumber, setSystemNumber] = useState('');
    const [Number, setNumber] = useState('');
    const [SerialNo, setSerialNo] = useState('');
    const [User, setUser] = useState('');
    const [UserId, setUserId] = useState(General.GuidEmpty());
    const [BeginDate, setBeginDate] = useState(moment(new Date()).add("Day", -7));
    const [EndDate, setEndDate] = useState(moment(new Date()));
    const [RegisterBeginDate, setRegisterBeginDate] = useState(moment(new Date()).add("Day", -7));
    const [RegisterEndDate, setRegisterEndDate] = useState(moment(new Date()));
    const [expandedRowKeys, setExpandedRowKeys] = React.useState([0]);
    const [loading, setLoading] = React.useState(false)

    //#endregion

    const handleExpanded = (rowData) => {
        let open = false;
        const nextExpandedRowKeys = [];
        expandedRowKeys.forEach(key => {

            if (key === rowData[rowKey]) {
                open = true;
            } else if (key != undefined) {
                nextExpandedRowKeys.push(key);
            }
        });

        if (!open) {
            nextExpandedRowKeys.push(rowData[rowKey]);
        }

        setExpandedRowKeys(nextExpandedRowKeys);
    };

    const User_Select = (e) => {
        setUserId(e.split("|")[0])
        setUser(e.split("|")[1])
    }

    const User_Change = (e) => {
        console.dir(e)
        setUserId(General.GuidEmpty())
        if (e.split("|").length > 1) {
            setUser(e.split("|")[1]);
            return;
        }
        setUser(e);
        UserRef.current.BindCoWorker(e)

    }

    const BeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }


    const RegisterBeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setRegisterBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const RegisterEndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setRegisterEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }


    //#region Methods


    const Search = () => {

        var RequestOptions = {
            data: {
                'FiscalYearId': FiscalYearId * 1,
                'CreateUserId': UserId,
                'SaveType': SaveType * 1,
                'State': State * 1,
                'Comment': Comment,
                'Number': Number == "" ? 0 : Number * 1,
                'SerialNo': SerialNo == "" ? 0 : SerialNo * 1,
                'SystemNumber': SystemNumber == "" ? 0 : SystemNumber * 1

            },
            url: General.ApiRoute() + "/Account_Doc/SearchHeader",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'BeginDate': BeginDate != null ? moment(BeginDate.format()).format("jYYYY/jMM/jDD") : "",
                'EndDate': EndDate != null ? moment(EndDate.format()).format("jYYYY/jMM/jDD") : "",
                'RegisterBeginDate': RegisterBeginDate != null ? moment(RegisterBeginDate.format()).format("jYYYY/jMM/jDD") : "",
                'RegisterEndDate': RegisterEndDate != null ? moment(RegisterEndDate.format()).format("jYYYY/jMM/jDD") : "",
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var tmp = []
                    console.dir(result.data)
                    console.dir(result.data.length)
                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Id: result.data[i].id,
                            CreateUser: result.data[i].createUser,
                            Number: result.data[i].number,
                            SaveType_Comment: result.data[i].saveType_Comment,
                            SaveType: result.data[i].saveType,
                            DocTypeTitle: result.data[i].docTypeTitle,
                            RegisterDate: result.data[i].registerDate,
                            CreateDate: result.data[i].createDate,
                            State: result.data[i].state == 0 ? "پیش نویس" : result.data[i].state == 1 ? "موقت" : "دایم",
                            SerialNo: result.data[i].serialNo,
                            SystemNumber: result.data[i].systemNumber,
                            Comment: result.data[i].comment,
                            TotalPrice: PN.sliceNumber(result.data[i].totalPrice),
                            children: result.data[i].children,

                        })
                    }
                    setList(tmp)
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }





    const ShowDetail = (id) => {

        setDetailModal(true);
        setId(id);


    }


    const Print = (id) => {
        navigate("/PrintDoc")
        localStorage.setItem("BackPage", "Doc");
        localStorage.setItem("DocHeaderId", id)
    }



    const ShowNew = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 33);
        myHeaders.append("Operation", 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')
                    }
                    else {
                        localStorage.setItem("DocHeaderId", General.GuidEmpty())
                        navigate("/InsertDoc")

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const ShowEdit = (Id) => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 33);
        myHeaders.append("Operation", 2);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')
                    }
                    else {
                        localStorage.setItem("DocHeaderId", Id)
                        navigate("/InsertDoc")

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 33);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                        UserRef.current.BindCoWorker("");
                        DocSaveTypeRef.current.Bind();
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const handelKeyDown = (e, row) => {
        if (e.key == "Enter") {
            Search();
        }
        if (e.shiftKey && e.code === "KeyN") {
            ShowNew();
        }

    }

    useEffect(() => {
        CheckPermission();
        document.title = "لیست اسناد حسابداری";
        const inputElement = document.querySelector('.FocusItem');
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion







    return (

        <Layout title="لیست اسناد حسابداری">


            <div className="h-100 p-1" onKeyDown={handelKeyDown}>
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>

                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> از تاریخ ثبت </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>تا تاریخ ثبت </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> از تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={RegisterBeginDate} onChange={RegisterBeginDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>تا تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={RegisterEndDate} onChange={RegisterEndDate_Change} />
                        </rsuite.Col>
                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>شماره سیستمی سند   </label>
                            <rsuite.Input value={SystemNumber} onChange={(e) => setSystemNumber(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>عطف سند </label>
                            <rsuite.Input value={Number} onChange={(e) => setNumber(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>سریال سند </label>
                            <rsuite.Input value={SerialNo} onChange={(e) => setSerialNo(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>نوع ثبت سند </label>
                            <Drp_DocSaveType className="rs-input" value={SaveType} onChange={(value) => setSaveType(value)} ref={DocSaveTypeRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> کاربر </label>
                            <Auto_User className="rs-input" value={User} onChange={User_Change} onSelect={User_Select} ref={UserRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> شرح </label>
                            <rsuite.Input value={Comment} onChange={(e) => setComment(e)} />
                        </rsuite.Col>
                    </rsuite.Row>


                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    rowKey={rowKey}
                                    rowExpandedHeight={rowData => {
                                        return (
                                            rowData.children.length == 1 ? 100 : rowData.children.length == 2 ? 160 : rowData.children.length * 75)
                                    }}

                                    height={500}
                                    data={List}
                                    expandedRowKeys={expandedRowKeys}
                                    loading={loading}
                                    renderRowExpanded={rowData => {
                                        return (
                                            <div>
                                                <rsuite.Table
                                                    data={rowData.children}
                                                    loading={loading}
                                                    autoHeight={true}
                                                    className='text-black-50'
                                                    wordWrap
                                                >
                                                    <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                        <rsuite.Table.HeaderCell> گروه حساب </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {rowData.acc_GTitle} [{rowData.acc_GLCode}]                                                                          {rowData.transferTypeComment}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                        <rsuite.Table.HeaderCell> حساب کل </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {rowData.acc_GLTitle} [{rowData.acc_GCode}{rowData.acc_GLCode}]                                                                          {rowData.transferTypeComment}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                        <rsuite.Table.HeaderCell> حساب معین </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {rowData.acc_CTitle} [{rowData.acc_GCode}{rowData.acc_GLCode}{rowData.acc_CCode}]                                                                          {rowData.transferTypeComment}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                        <rsuite.Table.HeaderCell> سطوح تفصیلی </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        <text className={rowData.sub_Acc_Id1 != General.GuidEmpty() ? "" : 'hide'}>
                                                                            {rowData.sub_Acc_LTitle1} [{rowData.sub_Acc_LCode1}] <br />
                                                                        </text>
                                                                        <text className={rowData.sub_Acc_Id2 != General.GuidEmpty() ? "" : 'hide'}>
                                                                            {rowData.sub_Acc_LTitle2} [{rowData.sub_Acc_LCode2}] <br />
                                                                        </text>
                                                                        <text className={rowData.sub_Acc_Id3 != General.GuidEmpty() ? "" : 'hide'}>
                                                                            {rowData.sub_Acc_LTitle3} [{rowData.sub_Acc_LCode3}]
                                                                        </text>
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={3} fullText resizable>
                                                        <rsuite.Table.HeaderCell> توضیحات</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey="comment" />
                                                    </rsuite.Table.Column>


                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell> بستانکار (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <text className='text-success '>
                                                                        {PN.sliceNumber(rowData.creditPrice)}
                                                                    </text>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell> بدهکار (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <text className='text-danger '>
                                                                        {PN.sliceNumber(rowData.debitPrice)}
                                                                    </text>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>


                                                </rsuite.Table>
                                            </div>
                                        );
                                    }}

                                >

                                    <rsuite.Table.Column className="w-10p" align="center" fixed >
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {expandedRowKeys.some(key => key === rowData[rowKey]) ? (
                                                        <BiIcon.BiMinusCircle size='12px' color='red' appearance="subtle"
                                                            onClick={() => {
                                                                handleExpanded(rowData);
                                                            }} />
                                                    ) : (
                                                        <BiIcon.BiPlusCircle size='12px' color='green' appearance="subtle"
                                                            onClick={() => {
                                                                handleExpanded(rowData);
                                                            }} />
                                                    )}

                                                    &nbsp;&nbsp; {rowData.row}
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText flexGrow={2} resizable>
                                        <rsuite.Table.HeaderCell>تاریخ ثبت سیستمی</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="CreateDate" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={2} resizable>
                                        <rsuite.Table.HeaderCell>تاریخ سند</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="RegisterDate" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>شماره سند</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Number" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>عطف سند</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="SystemNumber" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>سریال سند</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="SerialNo" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={2} resizable>
                                        <rsuite.Table.HeaderCell>نوع ثبت سند</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="SaveType_Comment" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={2} resizable>
                                        <rsuite.Table.HeaderCell>کاربر  </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="CreateUser" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={3} resizable>
                                        <rsuite.Table.HeaderCell>شرح  </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Comment" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={2} resizable>
                                        <rsuite.Table.HeaderCell>مبلغ  </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="TotalPrice" />
                                    </rsuite.Table.Column>


                                    <rsuite.Table.Column fixed="right" width={60} >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                {/* <rsuite.Dropdown.Item onClick={() => ShowDetail(rowData.Id)}>جزییات</rsuite.Dropdown.Item> */}
                                                                <rsuite.Dropdown.Item className={rowData.SaveType == 0 ? '' : "hide"} onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => Print(rowData.Id)}>چاپ   </rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div >
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>
                            <small><b> Shift+N :</b> جدید<b>| Enter :</b> جستجو </small>
                        </rsuite.Col>
                    </rsuite.Row>

                </rsuite.Panel >
            </div >



            {/* <Modal show={DetailModal} onHide={() => setDetailModal(false)} size="xl" backdrop="static" keyboard={false}>
                <Modal.Header >

                    <Modal.Title className='fs-5'> جزییات سند به شماره: {SystemNumber} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>

                            </rsuite.Col>
                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="subtle" onClick={() => Print()}>
                        چاپ
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setDetailModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal> */}

            {/* <Delete ref={DeleteRef} onSubmit={Search} /> */}
        </Layout >


    )
}

export default DocIndex;